var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import UiPopupMenu from '../UiPopupMenu.vue';
import UiTextButton from '../UiTextButton.vue';
import UiSecondaryButton from '../UiSecondaryButton.vue';
import Quill from 'quill';
import { UrlFormat, UrlOptions } from './quill/UrlFormat';
import UiToggle from '../UiToggle.vue';
import ValidationService from 'services/ValidationService';
import { container } from 'tsyringe';
Quill.register(UrlFormat);
var validationService = container.resolve(ValidationService);
var UiSimpleEditorToolbar = /** @class */ (function (_super) {
    __extends(UiSimpleEditorToolbar, _super);
    function UiSimpleEditorToolbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.quill = null;
        _this.urlOptions = new UrlOptions();
        _this.popupWidth = 438;
        return _this;
    }
    Object.defineProperty(UiSimpleEditorToolbar.prototype, "hasValidInput", {
        get: function () {
            var _a, _b;
            return validationService.isUrl((_a = this.urlOptions) === null || _a === void 0 ? void 0 : _a.label) || validationService.isUrl((_b = this.urlOptions) === null || _b === void 0 ? void 0 : _b.url);
        },
        enumerable: false,
        configurable: true
    });
    UiSimpleEditorToolbar.prototype.setQuill = function (quill) {
        this.quill = quill;
    };
    UiSimpleEditorToolbar.prototype.insertLink = function () {
        var _this = this;
        this.$nextTick(function () {
            var range = _this.quill.getSelection(true);
            if (range.length) {
                _this.quill.deleteText(range.index, range.length);
            }
            if (validationService.isUrl(_this.urlOptions.label) && !_this.urlOptions.url) {
                _this.urlOptions.url = _this.urlOptions.label;
            }
            _this.quill.insertText(range.index, _this.urlOptions.label ? _this.urlOptions.label : _this.urlOptions.url);
            _this.quill.setSelection(range.index, _this.urlOptions.label.length);
            _this.quill.format('url', _this.urlOptions);
            _this.$refs.urlForm.close();
            _this.urlOptions = new UrlOptions();
        });
    };
    UiSimpleEditorToolbar.prototype.formatH2 = function () {
        var formats = this.currentFormat;
        if (formats === null || formats === void 0 ? void 0 : formats.header) {
            this.quill.format('header', false);
        }
        else {
            this.quill.format('header', 2);
        }
    };
    Object.defineProperty(UiSimpleEditorToolbar.prototype, "currentFormat", {
        get: function () {
            if (!this.quill) {
                return {};
            }
            if (!this.quill.getSelection()) {
                return {};
            }
            var range = this.quill.getSelection();
            this.urlOptions.label = this.quill.getText(range.index, range.length);
            return this.quill.getFormat();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UiSimpleEditorToolbar.prototype, "isWideEnough", {
        get: function () {
            return this.popupWidth > 350;
        },
        enumerable: false,
        configurable: true
    });
    UiSimpleEditorToolbar.prototype.mounted = function () {
        var maxWidth = 438;
        var width = this.$refs.wrapper.clientWidth;
        this.popupWidth = width < maxWidth ? width : maxWidth;
    };
    UiSimpleEditorToolbar = __decorate([
        Component({
            components: {
                UiToggle: UiToggle,
                UiSecondaryButton: UiSecondaryButton,
                UiTextButton: UiTextButton,
                UiPopupMenu: UiPopupMenu,
            },
        })
    ], UiSimpleEditorToolbar);
    return UiSimpleEditorToolbar;
}(Vue));
export default UiSimpleEditorToolbar;
